import { PropsWithChildren } from 'react';
import { HeroUIProvider, ToastProvider } from '@heroui/react';

export const ThemeProvider = ({ children }: PropsWithChildren) => (
  <HeroUIProvider locale="en-GB">
    <ToastProvider placement="top-right" toastOffset={10} />
    {children}
  </HeroUIProvider>
);


